import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { orderSummaryByDate } from '../../../containers/Pages/Edd/EddUtils';

const EddSummary = memo(props => {
  const { fileDetails } = props;
  const reorderedInfo = orderSummaryByDate(fileDetails);

  return (
    <div className="border-none border-4 visible over border-green-200 w-[30%] 2xl:w-[35%]">
      <div className="w-full pb-2  mt-8 shadow-2xl z-40 shadow-[20px_20px_60px_#bebebe_-10px_-20px_60px_#ffffff] shadow-[#bebebe] ">
        <div className="w-full h-[725px] overflow-y-auto  bg-white/30 backdrop-blur-[24px] outline-solid outline-white  ">
          <div className="flex justify-between  border-b-[1px]  pb-2">
            <p className="font-bold text-dark-night mt-6 ml-6  items-center">Edd Summary</p>
          </div>

          <div className="items-start flex flex-col ml-2 mr-2 2xl:ml-6 2xl:mr-6 mt-4 border-b-[1px] pb-16 border-none">
            <div className="flex flex-col items-center ">
              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[0].component}
                <p className="absolute top-[14px] left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-72 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[0].title}
                </p>
                <p
                  data-test={reorderedInfo[0].testData}
                  className="absolute top-[48px] left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-72  bottom-2 block text-xs 2xl:text-sm"
                >
                  {reorderedInfo[0].subtitle}
                </p>
              </div>

              <div className="w-[2px] -translate-x-[12px]  2xl:translate-x-[0px] bg-green-100 h-28" />

              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[1].component}
                <p className="absolute top-[14px] left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-72 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[1].title}
                </p>
                <p
                  data-test={reorderedInfo[1].testData}
                  className="absolute top-[48px] left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-72  bottom-2 block text-xs 2xl:text-sm"
                >
                  {reorderedInfo[1].subtitle}
                </p>
              </div>

              <div className="w-[2px] -translate-x-[12px]  2xl:translate-x-[0px]   bg-green-100 h-28" />

              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[2].component}
                <p className="absolute top-[14px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-80 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[2].title}
                </p>
                <p
                  data-test={reorderedInfo[2].testData}
                  className="absolute top-[48px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-80  bottom-2 block text-xs 2xl:text-sm"
                >
                  {reorderedInfo[2].subtitle}
                </p>
              </div>

              <div className="w-[2px] -translate-x-[12px]  2xl:translate-x-[0px]   bg-green-100 h-28" />

              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[3].component}
                <p className="absolute top-[14px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-80 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[3].title}
                </p>
                <p
                  className="absolute top-[48px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-80 bottom-2 block text-xs 2xl:text-sm"
                  data-test={reorderedInfo[3].testData}
                >
                  {reorderedInfo[3].subtitle}
                </p>
              </div>
              <div className="w-[2px] -translate-x-[12px]  2xl:translate-x-[0px]   bg-green-100 h-28" />
              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[4].component}
                <p className="absolute top-[14px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-80 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[4].title}
                </p>
                <p
                  className="absolute top-[48px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-80 bottom-2 block text-xs 2xl:text-sm"
                  data-test={reorderedInfo[4].testData}
                >
                  {reorderedInfo[4].subtitle}
                </p>
              </div>

              <div className="w-[2px] -translate-x-[12px]  2xl:translate-x-[0px]   bg-green-100 h-28" />
              <div className="relative w-[48px] overflow-visible">
                {reorderedInfo[5].component}
                <p className="absolute top-[14px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center font-bold  w-80 bottom-2 block text-dark-night text-xs 2xl:text-sm">
                  {reorderedInfo[5].title}
                </p>
                <p
                  className="absolute top-[48px]  left-[32px]  2xl:left-[48px] text-start 2xl:text-center w-80 bottom-2 block text-xs 2xl:text-sm"
                  data-test={reorderedInfo[5].testData}
                >
                  {reorderedInfo[5].subtitle}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

EddSummary.propTypes = {
  fileDetails: PropTypes.object,
};

export default EddSummary;
